import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

// Founding year: 2021 → 5 years in 2026, increases +1 each year
const FOUNDING_YEAR = 2021;

// Clients base: 250 in March 2026, +5 every 2 months
const CLIENTS_BASE = 250;
const CLIENTS_BASE_DATE = new Date(2026, 2, 1); // March 2026
const CLIENTS_INCREMENT = 5;
const CLIENTS_INCREMENT_MONTHS = 2;

function calculateYears(): number {
  const now = new Date();
  return now.getFullYear() - FOUNDING_YEAR;
}

function calculateClients(): number {
  const now = new Date();
  const diffMs = now.getTime() - CLIENTS_BASE_DATE.getTime();
  const diffMonths = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24 * 30.44)));
  const increments = Math.floor(diffMonths / CLIENTS_INCREMENT_MONTHS);
  return CLIENTS_BASE + increments * CLIENTS_INCREMENT;
}

export function useDynamicStats() {
  const [soldCount, setSoldCount] = useState<number>(0);
  const years = calculateYears();
  const clients = calculateClients();

  useEffect(() => {
    async function fetchSoldCount() {
      const { count, error } = await supabase
        .from("sales")
        .select("*", { count: "exact", head: true });

      if (!error && count !== null) {
        setSoldCount(count);
      }
    }
    fetchSoldCount();
  }, []);

  return { soldCount, years, clients };
}
